var ENGINE = ENGINE || {};
/* 変数
---------------------------------------------------------- */
ENGINE.el = {
	$html    : $('html'),
	$body    : $('body'),
	$page    : $('.l_page'),
	$header  : $('.l_header'),
	$main    : $('.l_main'),
	$footer  : $('.l_footer')
};

$(function(){
	$('a[href^="#"]').click(function() {
		var href= $(this).attr("href");
		var parent_flag = $(this).parents(" .prevention_dog, .prevention_cat");

		if((href != "#prevention_dog")&&(href != "#prevention_cat") && !parent_flag[0])  {
			var speed = 400;// ミリ秒
			var href= $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			return false;
		} else{ 
			return false;
		}
	});
});


//テーブル縦横逆転
$(function(){
	
	function switchColsAndRows(tabid){
		var cols = [];
		var rowIndex = 0;
		var maxColSize = 0;
		var tab = $('#' + tabid);
		// colspan
		tab.find('tr').each(function(){
			if(!cols[rowIndex]){ cols[rowIndex] = []; }
			var colIndex = 0;
			$(this).find('td, th').each(function(){
				var colspan = $(this).attr('colspan');
				var colsize = (!colspan)?1:parseInt(colspan);
				cols[rowIndex][colIndex] = $(this)[0];
				for(var k = 1; k < colsize; k++){
					cols[rowIndex][colIndex + k]={ omittable:true, rowspan:$(this).attr('rowspan')};
				}
				colIndex += colsize;
				maxColSize = (cols[rowIndex].length > maxColSize)?cols[rowIndex].length:maxColSize;
			});
			rowIndex++;
		});
		// rowspan
		for(var i = 0; i < cols.length; i++){
			for(var j = 0; j < cols[i].length; j++){
				var rowspan = $(cols[i][j]).attr('rowspan');
				rowspan = (rowspan)?rowspan:cols[i][j].rowspan;
				var rowsize = (!rowspan)?1:parseInt(rowspan);
				for(var x = 1; x < rowsize && cols[i+x]; x++){
					cols[i+x].splice(j, 0, { omittable : true, rowspan : 1});
				}
			}
		}
		tab.empty();
		var initAttr = function(elm,name,val){$(elm).removeAttr(name);$(elm).attr(name, val);};
		var replaceAttr = function(elm,name1,name2,v1,v2){
			v1=$(elm).attr(name1);v2=$(elm).attr(name2);
			initAttr(elm,name1,v2);initAttr(elm,name2,v1);
		};
		// table
		for(var i = 0; i < maxColSize; i++){
			var tr = $('<tr />');
			for(var j = 0; j < cols.length; j++){
				if(cols[j] && cols[j][i] && (!cols[j][i].omittable)){
					var col = cols[j][i];
					replaceAttr(col, 'rowspan', 'colspan');
					tr.append(col);
				}
			}
			tab.append(tr[0]);
		}
	}
	$(window).on('load resize', function() {
		winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		$table_id = 'table';
		var tabel_array = ['table', 'table2'];
		$.each(tabel_array, function() {
			if(winW < 750) {
				if ($('#' + this).hasClass('is-tableSpChange')) {
				}else {
					switchColsAndRows(this);
					$('#' + this).addClass('is-tableSpChange');
				}

			}else {
				if ($('#' + this).hasClass('is-tableSpChange')) {
					switchColsAndRows(this);
					$('#' + this).removeClass('is-tableSpChange');
				}
			}
		})
	});
	
});
// tab
ENGINE.tab = {
	init: function() {
		$('.m_tab .m_tab--btn__item').click(function() {
			var index = $('.m_tab .m_tab--btn__item').index(this);
			$('.m_tab .m_tab--btn__item, .m_tab .m_tab--panel__item').removeClass('is-active');
			$(this).addClass('is-active');
			$('.m_tab .m_tab--panel__item').eq(index).addClass('is-active');
		});
	}
};
// table
ENGINE.table = {
	init: function() {
	}
};
ENGINE.accobtn = {
	init: function() {
		function _acco($this) {
			if ($this.hasClass('is-accoOpen')) {
				$this.removeClass('is-accoOpen');
			} else {
				$this.addClass('is-accoOpen');
			}
			$this.next().slideToggle(300);
		}
		$('.js-accoBtn').on('click', function() {
			_acco($(this));
		});
	}
};
ENGINE.select_prefecture = {
	init: function() {
		var $form = $('form.select_prefecture');
		$(".select_prefecture select").on('change', function() {
			$form.submit();
/**
			$(".prefecture_box").hide();
			$(".prefecture_" + target_prefecture).show();
*/

		});
	}
};
ENGINE.scroll = {
	init: function() {
		$(window).on('load', function() {
			var hasHash = location.hash;
			winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			
			if(hasHash) {
				$('body, html').stop().scrollTop(0);
				setTimeout(function(){
					var target = $(hasHash);
					var position = target.offset().top;
					$('body,html').stop().animate({scrollTop: position}, 500, 'swing');
				}, 200);
			}
			$('.js-scroll a[href^="#"], a.js-scroll[href^="#"]').on('click', function() {
				if (typeof $($(this).attr('href')).offset().top !== 'undefined') {
					$('html, body').animate({
						scrollTop: $($(this).attr('href')).offset().top
					}, 500, 'swing');
				}
				return false;
			});
		});
	}
};

ENGINE.calculator = {
	init: function() {

		var $total_tax = $('.js-total-tax');
		var $total     = $('.js-total');
		var $selector  = $('.js-medicine');

		var $pet_type = $('.js-calculate-pettype');
		var pet_type  = '';
		var $total_tax_pet_type = false;

		var is_init_calc = false;
		var $result_selector = $('.js-total.is-result-selector');
		if ($result_selector.length > 0) {
			is_init_calc = true;
		}

		if (($total_tax.length > 0) && ($total.length > 0) && ($selector.length > 0) && ($pet_type.length == 1)) {

			pet_type = ($pet_type.val()=='2')?'cat':'dog';
			$total_tax_pet_type = $('.js-total-tax-' + pet_type);
			$hid_total_tax_pet_type = $('.js-total-tax-hid-' + pet_type);

			//////////////////////////////////////////////////////////////////////
			// 相互チェック制御（合剤と個別薬剤）
			//////////////////////////////////////////////////////////////////////
			var $ctr_radio_default = $('.js-check-controller-default');
			var $ctr_radio_mixture = $('.js-check-controller-mixuture');
			var $ctr_radio_nomi_madani = $('.js-check-controller-nomi_madani');
			var checked_nomi_madani = $ctr_radio_nomi_madani.filter(':checked').val();

			var ctr_radio_group = {};
			// ラジオボタンは複数のフィールド名の項目が対象になるため、フィールド名を取得
			// ※合剤が選択されている状態で、フィラリア or ノミ・マダニがクリックされた場合
			$ctr_radio_default.each(function() {
				var name = $(this).attr('name');
				ctr_radio_group[name] = true;
			});

			// ラジオボタン（犬用のチェック）
			// ラジオボタンがclickされたとき、チェックボックスのチェックを外す
			$ctr_radio_default.on('change', function() {
				$ctr_radio_mixture.prop('checked', false);

				var $this = $(this);
				var checked_fld_name = $this.attr('name');

				for(var fld_name in ctr_radio_group) {
					// var target_name = 
					if (fld_name != checked_fld_name) {
						var $target_fld = $('.js-check-controller-default[name="' + fld_name + '"]:checked');
						if ($target_fld.length == 0) {
							$target_fld = $('.js-check-controller-default[name="' + fld_name + '"]');
							$target_fld.eq(0).prop('checked', true);
						}
					}
				}

				// ノミ・マダニにチェックがない場合
				if ($ctr_radio_nomi_madani.filter(':checked').length == 0) {
					// var $tmp = $ctr_radio_nomi_madani.filter('value=' + checked_nomi_madani);
					$ctr_radio_nomi_madani.eq(0).prop('checked', true);
				}
			});
			// ラジオボタン（犬用・合剤のチェック）
			$ctr_radio_mixture.on('change', function() {
				$ctr_radio_default.prop('checked', false);
			});

			// ラジオボタン（犬用・ノミマダニのチェック）
			$ctr_radio_nomi_madani.on('click', function() {
				var $this = $(this);
				if($this.val() === checked_nomi_madani) {
					if ($ctr_radio_mixture.filter(':checked').length > 0) {
						$this.prop('checked', false);
						checked_nomi_madani = '';
					}
				} else {
					$this.prop('checked', true);
					checked_nomi_madani = $this.val();
				}
			});

			//////////////////////////////////////////////////////////////////////
			// 計算
			//////////////////////////////////////////////////////////////////////
			$selector.on('change', function() {
				_calculate();
			});
			// 初期計算
			if (is_init_calc) {
				_calculate();
			}

			function _calculate() {
				var total=0, total_tax=0;
				$('.js-medicine:checked').each(function() {
					var $this = $(this);
					var amount = $this.data('amount');
					var amount_tax = $this.data('amount-tax');

					total += Number(amount);
					total_tax += Number(amount_tax);
				});


				$total.text(total.toLocaleString());
				$total_tax.text(total_tax.toLocaleString());
				$total_tax_pet_type.text(total_tax.toLocaleString());

				$hid_total_tax_pet_type.val(total_tax.toLocaleString());
			}

		}
	}
};

ENGINE.fixedResultTable = {
	init: function() {

		// const wrapper = document.querySelector('#result-fixed');
		var target = document.querySelector('#js-fixed-observe');

		if (!target) return false;

		var $win  = $(window);
		var $base = $('#js-fixed-base');
		var $box  = $('#js-fixed-box');
		var baseTop    = $base.offset().top;
		var baseHeight = $base.height();
		var baseTopMax = baseTop + baseHeight - $win.height();
		var interavlID = 0;

		var observer = new IntersectionObserver((entries) => {
	   // entriesは監視対象すべてが入っているリスト
	   for(var e of entries) {
	      // isIntersecting プロパティは交差しているかどうかの真偽値
	      // viewport に交差し、入ったときに isIntersecting === true、出たときに false になる
	      if(e.isIntersecting) {
					$win.on('scroll', _fixedCol);
					$win.on('resize', _resetBase);
	      } else {
					$win.off('scroll', _fixedCol);
					$win.off('resize', _resetBase);
	      }
	    }
	  });

	  function _resetBase() {
			baseTop    = $base.offset().top;
			baseHeight = $base.height();
			baseTopMax = baseTop + baseHeight - $win.height();
	  }

	  function _fixedController() {

	  }

		/**
		 *
		 *
		 */
		function _fixedCol() {
			if ( (baseTop < $win.scrollTop()) && ($win.scrollTop() < baseTopMax) ) {
				// console.log(baseTop + ' : ' + $win.scrollTop() + ' : ' + baseTopMax);
				// console.log($box.length + ' : ' + ($win.scrollTop() - baseTop));
				$box.css('top', ($win.scrollTop() - baseTop));
			}
		}
	  // observe メソッドに監視対象要素を引数として渡すことで監視されるようになります
	  observer.observe(target);
	}

};

ENGINE.validator = {
	init: function() {
		$('.js-condition-form').each(function() {
			var $form = $(this);
			$form.on('submit', function(e) {

				var $weight = $form.find('.js-condition-form--weight');
				var weight  = $weight.val();

				weight = _convertZen2Han(weight);
				$weight.val(weight);

			});
		});

		var _convertZen2Han = function(str) {
			 var str = str + '';
			// 英字変換
			str = str.replace(/[Ａ-Ｚａ-ｚ]/g, function (s) {
					return String.fromCharCode(s.charCodeAt(0) - 65248);
				});

			// 数字変換
			str = str.replace(/[０-９]/g, function (s) {
					return String.fromCharCode(s.charCodeAt(0) - 65248);
				});

			// 記号変換
			var reg = /[！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
			str = str.replace(reg, function (s) {
					return String.fromCharCode(s.charCodeAt(0) - 65248);
				}).replace(/[‐－―−]/g, '-');

			// チルダ変換
			str = str.replace(/[～〜]/g, '~');
			// スペース変換
			str = str.replace(/　/g, ' ');

			return str;
		};

	},


};


// 各種処理実行（初期処理呼び出し）
window.addEventListener('DOMContentLoaded', function() {
	//タブ
	ENGINE.tab.init();
	//アコーディオン
	ENGINE.accobtn.init();
	//都道府県選択
	ENGINE.select_prefecture.init();
	//タブ
	ENGINE.scroll.init();

	ENGINE.fixedResultTable.init();

	ENGINE.validator.init();
	// 
	ENGINE.calculator.init();
});